<p-dialog
          header="{{ document.id ? ('fs.res.common.documents.editDocument'|hisUi) : ('fs.res.common.documents.assignDocument'|hisUi) }}"
          [(visible)]="visibility" [modal]="true" height="auto" (onHide)="closeDialog()" [draggable]="false"
          [blockScroll]="true">

    <div class="layoutBlock">
        <div class="columnFullWidth">
            <his-plam #addFilePlam *ngIf="!hisUploadFiles.length && confKey">
                <his-file-upload #content #addFileInput [configKey]="confKey" [(ngModel)]="hisUploadFiles">
                    <div customModelContent></div>
                </his-file-upload>
            </his-plam>

            <div *ngIf="hisUploadFiles.length">
                <p-panel header="{{'I18nValue.basicData' | hisUi}}">
                    <his-plam [label]="documentLabelPrefix + documentLabel">
                        <div #content>
                            <span class="plamContentText">{{hisUploadFiles[0].name}}</span>

                            <his-upload-file-download [value]="hisUploadFiles[0]"></his-upload-file-download>

                            <button id="delete" hisImage="DELETE" class="transparent" (click)="removeFile()"
                                    [title]="'common.removeOf' | hisUi: hisUploadFiles[0].name">
                            </button>
                        </div>
                    </his-plam>
                    <his-plam>
                        <p-autoComplete #content [hisDdKey]="'fs.res.publication.PublicationDocumentMetadata.category'"
                                        [dropdown]="true" [forceSelection]="true" field="defaulttext"
                                        [(ngModel)]="selectedCategory"
                                        [suggestions]="filteredCategories" (completeMethod)="filterCategories($event)">
                        </p-autoComplete>
                    </his-plam>
                    <his-plam>
                        <input #content [hisDdKey]="'fs.res.publication.PublicationDocumentMetadata.title'"
                               class="inputWidth100" [(ngModel)]="document.title">
                    </his-plam>
                    <his-plam>
                        <input #content [hisDdKey]="'fs.res.publication.PublicationDocumentMetadata.comment'"
                               class="inputWidth100" [(ngModel)]="hisUploadFiles[0].comment">
                    </his-plam>
                </p-panel>
                <p-panel
                         header="{{'fs.res.publication.publicationDocuments.fieldset.publicationInRepository' | hisUi}}">
                    <div *ngIf="isPublicationInRepositoryDivVisible()" id="publicationInRepositoryDiv">
                        <his-plam>
                            <p-autoComplete #content
                                            [hisDdKey]="'fs.res.publication.PublicationDocumentMetadata.access'"
                                            [(ngModel)]="document.access" hisEagerDataSource="documentAccessTypeValue">
                            </p-autoComplete>
                        </his-plam>
                        <his-plam>
                            <p-calendar hisDdKey="fs.res.publication.PublicationDocumentMetadata.embargoDate" #content
                                        [(ngModel)]="document.embargoDate" appendTo="body"></p-calendar>
                        </his-plam>
                        <his-plam>
                            <p-autoComplete #content
                                            [hisDdKey]="'fs.res.publication.PublicationDocumentMetadata.accessAfterEmbargoDate'"
                                            [(ngModel)]="document.accessAfterEmbargoDate"
                                            hisEagerDataSource="documentAccessTypeValue">
                            </p-autoComplete>
                        </his-plam>
                        <his-plam>
                            <p-autoComplete #content
                                            [hisDdKey]="'fs.res.publication.PublicationDocumentMetadata.license'"
                                            [(ngModel)]="document.license" hisEagerDataSource="licenseValue">
                            </p-autoComplete>
                        </his-plam>
                    </div>
                    <br>
                    <div class="infoMessage"
                         *ngIf="!isHidden('fs.res.publication.PublicationDocumentMetadata.confirmation')"
                         [innerHTML]="'fs.res.publication.publicationDocuments.add.confirmationText' | hisUi"></div>
                    <his-plam>
                        <input #content type="checkbox" [(ngModel)]="document.confirmed"
                               hisDdKey="fs.res.publication.PublicationDocumentMetadata.confirmation" />
                    </his-plam>
                </p-panel>

            </div>
        </div>
    </div>

    <p-footer>
        <button (click)="applyChanges()"
                (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cancelBtn.focus();">
            <span>{{ 'common.apply' | hisUi }}</span>
        </button>
        <button #cancelBtn (click)="closeDialog()" (keydown.tab)="$event.stopPropagation();">
            <span>{{ 'common.cancel' | hisUi }}</span>
        </button>
    </p-footer>
</p-dialog>